exports.list = {
    path: '/laporan_konsistensi_data',
    name: 'laporan_konsistensi_data', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_konsistensi_data/List.vue"),
  }